import React, { useState } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BookingForm from './components/BookingForm';
import Home from './pages/Home';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';

// Required by system instructions
import '@questlabs/react-sdk/dist/style.css';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState('');

  const handleOpenModal = (serviceName = 'Garuda Reguler (G-Reg)') => {
    setSelectedService(serviceName);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <HashRouter>
      <div className="min-h-screen bg-white flex flex-col">
        <Navbar onBook={handleOpenModal} />
        
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home onBook={handleOpenModal} />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </div>

        <Footer />

        {/* Modal Form */}
        <BookingForm 
          isOpen={isModalOpen} 
          onClose={handleCloseModal} 
          defaultService={selectedService} 
        />
      </div>
    </HashRouter>
  );
}

export default App;